// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_OWR","right":"Footer_right__1dmFx","buttons":"Footer_buttons__1ljFP"};